
export default () => ({
    init() {  
    },
    subscribeBackinStock(){
        
        let email = document.getElementById("subscription-email_address");
        let customeremail = email.value
        let variantId = email.getAttribute('data');

        if(email == ""){
          return
        } 

        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            headers: {
                "accept": "application/json, text/plain, */*",
                "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
            }, 
            body: new URLSearchParams({
                "a": "UBDbs5",
                "email": customeremail,
                "platform": "shopify",
                "variant": variantId
            }),
            method: "POST",
            })
            .then(response => {
                return response.json()
            })
            .then(result => {
                document.querySelector('.backinstock-form-js').classList.add('hidden')
                document.querySelector('.success-js').classList.remove('hidden')
            })
            .catch(err => {
                console.error(err);
            });
        
        
        }
})